export default __webpack_public_path__ + "static/media/print.21afe77b.svg";